import Vue from 'vue'
import Vuex from 'vuex'
import Message from '@/components/message'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
  state: {
    current: Date.now(), // 当前时间
    intervalID: 0,
    message: undefined,
    link: null,
    showChat: false,
    logout: null,
    canSend: false,
    activeInfo: {},
    pinkUpGoods: false,
    delivery: false,
    selectType: 1,
    configInfo: {
      heardCharactersStyle: ['#ffffff', '#ffffff'],
      hotSearchStyle: ['#ffffff', '#ffffff']
    },
    anonymousID: ''
  },
  getters: {
    hidden() {
      if (typeof document.hasFocus !== 'function') {
        return document.hidden
      }
      return !document.hasFocus()
    },
    activeInfo: (state) => state.activeInfo,
    configInfo: (state) => state.configInfo
  },
  mutations: {
    changeselectType(state, newState) {
      state.selectType = newState
    },
    changePinkUpGoods(state, newState) {
      state.pinkUpGoods = newState
    },
    changedelivery(state, newState) {
      state.delivery = newState
    },
    SET_ACTIVEINFO(state, data) {
      state.activeInfo = data
    },
    SET_CONFIGINFO(state, data) {
      state.configInfo = data
    },
    startComputeCurrent(state) {
      state.intervalID = setInterval(() => {
        state.current = Date.now()
      }, 500)
    },
    stopComputeCurrent(state) {
      clearInterval(state.intervalID)
      state.intervalID = 0
    },
    showMessage(state, options) {
      if (state.message) {
        state.message.close()
      }
      state.message = Message({
        message: options.message,
        type: options.type || 'success',
        duration: options.duration || 2000,
        offset: 40
      })
    },
    // 设置神策 匿名id
    setAnonymousID(state, data) {
      state.anonymousID = data
    }
  },
  actions: {
    set_activeInfo({ commit }, data) {
      commit('SET_ACTIVEINFO', data)
    },
    set_configInfo({ commit }, data) {
      commit('SET_CONFIGINFO', data)
    },
    // 设置神策 匿名id
    SetAnonymousID({ commit }, data) {
      commit('setAnonymousID', data)
    }
  },
  modules
})

export default store
